export default {
  logo: require('./logo.png')
}


// WEBPACK FOOTER //
// ./src/assets/imgs/index.js